module.exports = __webpack_public_path__ + "img/tool_icon_1.0cb3789.png";